export const readTextFromBlob = async (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      const result = event?.target?.result

      if (!result || !(typeof result === 'string')) {
        reject(new Error('Unexpected result type'))
      } else {
        resolve(result)
      }
    }

    reader.readAsText(blob)
  })
}
